module.exports = ".ssf-paginator__wrapper {\n  text-align: right;\n  width: 100%;\n  margin: 0.5rem 0; }\n\n.ssf-paginator__pagination {\n  display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/paginator/paginator.component.scss
// module id = 622
// module chunks = 3